import { createTheme } from '@mui/material/styles';
import { typography } from './typography';
import { breakpoints } from './breakpoints';
import { components } from './components';
import { brandOverride } from '../clients/brandOverride';

export const defaultTheme = createTheme({
  typography,
  components,
  breakpoints,
  palette: {
    accent: {
      main: '#eff3f4',
      secondary: '#71767b',
    },
    background: {
      default: '#ffffff',
      secondary: '#f8f9fa',
    },
    primary: {
      main: '#ffffff',
    },
    secondary: {
      main: '#121212',
    },
    default: {
      main: '#ffffff',
    },
    error: {
      main: '#d32f2f',
    },
    neons: {
      pink: '#f000ff',
      blue: '#4deeea',
      green: '#74ee15',
      yellow: '#ffe700',
      orange: '#FF5F1F',
      purple: '#BC13FE',
      red: '#FF3131',
    },
    medal: {
      main: '#8A8987',
    },
    ...brandOverride().brandColors,
  },
});
